import { VehicleDetailResponse } from "models/vehicleResponse";
import { numberWithCommas, numberWithCommasAndSymbol } from "utils/commonUtils";

const DetailVehicle = ({
    vdpSettings,
    detail,
    companyInfo,
}: {
  vdpSettings: any;
  detail: VehicleDetailResponse;
  companyInfo: any;
}) => {
    const showStockNumber = vdpSettings.showStockNumber;
    const showVin = vdpSettings.showVin;
    const showMake = vdpSettings.showMake;
    const showModel = vdpSettings.showModel;
    const showYear = vdpSettings.showYear;
    const showMiles = vdpSettings.showMiles;
    const showColor = vdpSettings.showColor;
    const showTransmission = vdpSettings.showTransmission;
    const showEngine = vdpSettings.showEngine;
    const showStyle = vdpSettings.showStyle;
    const showTrim = vdpSettings.showTrim;
    const showPriceSaving = vdpSettings.showPriceSaving;

    //   const showLocation = vdpSettings.showLocation;
    //   const showPrice = vdpSettings.showPrice;
    //   const overridePriceByText = vdpSettings.overridePriceByText;
    //   const overridePriceText = vdpSettings.overridePriceText;

    return (
        <div className="details-block details-weight">
            {showPriceSaving && ((detail.nadaRetail > 0) && (detail.nadaRetail - detail.internetPrice) > 0) && (
                <table className="table-price">
                    <tbody>
                        <tr>
                            <td>JD Power</td>
                            <td className="strikethrough-font">{numberWithCommasAndSymbol(detail.nadaRetail)}</td>
                        </tr>
                        <tr>
                            <td className="italic-font">Savings</td>
                            <td className="italic-font">{numberWithCommasAndSymbol(detail.nadaRetail - detail.internetPrice)}</td>
                        </tr>
                    </tbody>
                </table>
            )}            
            <ul>
                {!detail.isSold && <li><div className="availableinlot">
                    <span>In Stock at {companyInfo.companyName} </span><span style={{fontWeight: 'bold'}}>{detail.lotName}</span>
                </div></li>
                }
                {showStockNumber && (
                    <li>
                        {" "}
                        <span>Stock #</span>{" "}
                        <strong className="text-left">{detail.stockNumber}</strong>
                    </li>
                )}

                {showVin && (
                    <li>
                        {" "}
                        <span>Vin</span> <strong className="text-left">{detail.vin}</strong>
                    </li>
                )}

                {showYear && (
                    <li>
                        {" "}
                        <span>Year </span>{" "}
                        <strong className="text-left">{detail.year}</strong>
                    </li>
                )}

                {showMake && (
                    <li>
                        {" "}
                        <span>Make</span>{" "}
                        <strong className="text-left">{detail.make}</strong>
                    </li>
                )}

                {showModel && (
                    <li>
                        {" "}
                        <span>Model</span>{" "}
                        <strong className="text-left">{detail.model}</strong>
                    </li>
                )}

                {showTrim && (
                    <li>
                        {" "}
                        <span>Trim</span>{" "}
                        <strong className="text-left">{detail.trim}</strong>
                    </li>
                )}

                {showStyle && (
                    <li>
                        {" "}
                        <span>Style</span>{" "}
                        <strong className="text-left">{detail.style}</strong>
                    </li>
                )}

                {showMiles && (
                    <li>
                        {" "}
                        <span>Mileage</span>{" "}
                        <strong className="text-left">
                            {numberWithCommas(detail.miles || 0)}
                        </strong>
                    </li>
                )}

                {showColor && (
                    <li>
                        {" "}
                        <span>Color</span>{" "}
                        <strong className="text-left">
                            {detail.extColor} / {detail.intColor}
                        </strong>
                    </li>
                )}

                {showTransmission && (
                    <li>
                        {" "}
                        <span>Transmission</span>{" "}
                        <strong className="text-left">{detail.transmission}</strong>
                    </li>
                )}

                {showEngine && (
                    <li>
                        {" "}
                        <span>Engine</span>{" "}
                        <strong className="text-left">{detail.engine}</strong>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default DetailVehicle;
